import { Checkbox } from '@material-ui/core';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export default class FlagsSharedUsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isListOpen: true
    };
  }

  handleListToggle = () => {
    this.setState({ isListOpen: !this.state.isListOpen });
  };

  render() {
    const {
      sharedUserList,
      searchedData,
      userFilterSelectedItems
    } = this.props;

    return (
      <div className="flags-filters-shared">
        <Row>
          <Col xs={12}>
            <div className="flags-filters-shared__header">
              <span className="flags-filters-shared__header-title">
                Shared by
              </span>
              <span onClick={this.handleListToggle} className="">
                <i
                  className={`fa fa-chevron-up  ${
                    !this.state.isListOpen ? 'fa-rotate-180' : ''
                  }`}
                ></i>
              </span>
            </div>
          </Col>
        </Row>
        {this.state.isListOpen ? (
          <Row>
            <Col xs={12}>
              <div className="flags-filters-shared__list">
                {sharedUserList(searchedData ? searchedData : [])?.map(
                  (listItem) => (
                    <div
                      key={listItem.userId}
                      className="flags-filters-shared__list-item"
                    >
                      <Checkbox
                        className="share-flags-modal__checkbox flags-filters-shared__checkbox"
                        checked={userFilterSelectedItems.includes(
                          listItem.userId
                        )}
                        onChange={() =>
                          this.props.handleUserFilterItemSelect(listItem)
                        }
                        icon={
                          <RadioButtonUncheckedIcon
                            fontSize="large"
                            style={{ color: '#212121' }}
                          />
                        }
                        checkedIcon={<CheckCircleIcon fontSize="large"  style={{color: 'lightgreen'}}/>}
                      />
                      <span className="list-item-title">{listItem.name}</span>
                    </div>
                  )
                )}
              </div>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        <Row>
          <Col xs={12}>
            <div className="flags-filter__divider"></div>
          </Col>
        </Row>
      </div>
    );
  }
}
